module.exports = __webpack_public_path__ + "static/img/Banner.4de8df04.jpg";